import { useEffect, useRef } from 'react';
import { useInView } from 'react-intersection-observer';
import { leftFromView } from 'utils/grid';

type LoadPageTriggerProps = {
  onVisible: (page: number) => void;
  page: number;
};

export function LoadPageTrigger({
  onVisible,
  page, // current Page index
}: LoadPageTriggerProps) {
  const { ref, inView, entry } = useInView({
    threshold: 0,
    rootMargin: '0% 0%',
  });
  const prevInView = useRef(inView);

  useEffect(() => {
    prevInView.current = inView;
    if (!inView && entry) {
      const leftDirection = leftFromView(entry.boundingClientRect.top, entry.boundingClientRect.bottom);
      const newPage = leftDirection === 'top' ? page + 1 : page - 1;
      onVisible(newPage);
    }
  }, [inView]);

  return <div data-middle={page} ref={ref}></div>;
}
